import React, { useState, useEffect, useContext } from 'react';
import { useCookies } from 'react-cookie';
import 'reactjs-popup/dist/index.css';
import AutoSlider from './AutoSlider';
import axios from 'axios';
import '../App.css';
import ModalComponent from './ModalComponent';
import { GlobleContext } from './utils';
import YouTubePlayer from './YouTubePlayer';

const Product = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL || '/';
    const productImgUrl = process.env.REACT_APP_Product_Images_URL;
    const brochureUrl = process.env.REACT_APP_Product_URL;
    const [cookies] = useCookies(['vsk_Cookie']);
    const [productItemDetailData, setProductItemDetailData] = useState([]);
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [dynamicData, setProductDynamicData] = React.useState(false);
    const [saveproductItemDetailID, setProductItemDetailID] = React.useState('');
    const [saveProductName, setProductName] = React.useState('');
    const { getProductCategoryData, productCategoryData } = useContext(GlobleContext)
    const [vskCookies, setvskCookies, removeCookie] = useCookies(['vsk_Cookie']);

    const [pageCount, setPageCount] = useState("6");
    const [tableData, setTableData] = useState([]);
    const [allTableData, setAllTableData] = useState([]);
    const [pageId, setPageId] = useState(1);

    useEffect(() => {
        getProductItemData();
        getProductCategoryData();
    }, []);

    const getProductItemData = async () => {
        const response = await axios.post(`${baseUrl}OurProduct/getProductDetail`,
            {
                PaginationID: "0",
                PageLength: pageCount,
                ProductCategoryID: cookies.PCID
            });
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                setProductItemDetailData(response.data.data);
                setTableData(response.data.data)
                setAllTableData(response.data.data)

                console.log("Datttttt", response.data.data);
            }
        }
    };

    const openModal = (data, ProductItemDetailID, ProductName) => {
        setProductDynamicData(data)
        setProductItemDetailID(ProductItemDetailID)
        setProductName(ProductName)
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const handleMenuClick = (ProductCategoryID) => {
        // Save data in the cookie
        removeCookie('PCID')
        setvskCookies('PCID', ProductCategoryID);
    };

    const handleNextData = () => {
        console.log(pageId, "pageID", pageCount);
        if (pageId * pageCount < allTableData.length) {
            const tempt = [...allTableData];
            console.log(tempt, pageId * pageCount, (pageId + 1) * pageCount);
            const sliced = tempt.slice(pageId * pageCount, (pageId + 1) * pageCount);
            setTableData(sliced);
            setPageId(pageId + 1);
            return;
        }
        const paginationIndex = allTableData[pageId * pageCount - 1]?.ProductItemDetailID;
        if (!paginationIndex) {
            return;
        }
        console.log(paginationIndex, "paginationIndex");
        fetch(`${baseUrl}OurProduct/getProductDetail`, {
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                PaginationID: `${paginationIndex}`,
                PageLength: `${pageCount}`,
                ProductCategoryID: cookies.PCID
            }),
        })
            .then((res) => res.json())
            .then((result) => {
                console.log(result.data);
                setTableData(result.data);
                if (result.status == 1) {
                    setPageId(pageId + 1);
                    setAllTableData([...allTableData, ...result.data]);
                }
            });
    };

    const handlepreviousData = () => {
        if (pageId == 1) {
            return;
        }
        const tempt = [...allTableData];
        console.log(pageId, "pageId");
        console.log(
            pageId,
            tempt,
            (pageId - 1) * pageCount,
            pageId * pageCount + 1
        );
        const sliced = tempt.slice(
            (pageId - 2) * pageCount,
            (pageId - 1) * pageCount
        );
        setTableData(sliced);
        setPageId(pageId - 1);
    };

    const nameToExclude = productItemDetailData.length > 0 ? productItemDetailData[0].ProductCategory : null;

    return (
        <>
            <div className="page-header title-area">
                <div className="header-title headerbgimg">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                {productItemDetailData &&
                                    <h1 className="page-title">
                                        {productItemDetailData.length > 0 ? productItemDetailData[0].ProductCategory : null}
                                    </h1>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <nav className="breadcrumb"><span>
                                    <a className="home" href="/Splash"><span>Home</span></a>
                                </span><i className="fa fa-angle-right" aria-hidden="true"></i>
                                    {productItemDetailData &&
                                        <span><span>{productItemDetailData.length > 0 ? productItemDetailData[0].ProductCategory : null}</span></span>
                                    }
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="content" className="site-content">
                <div className="container productcontpadding">
                    <div className="row margbtm40">
                        <div className="info col-md-12">
                            <h4 className="name">{productItemDetailData.length > 0 ? productItemDetailData[0].ProductCategory : null}</h4>
                            <p className='text-justify'>{productItemDetailData.length > 0 ? productItemDetailData[0].ProductDescription : null}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div id="primary" className="content-area col-md-9 col-sm-12 col-xs-12  woocommerce">
                            <div className="product">
                                {/* {console.log("ashajshashsjh", productItemDetailData)} */}
                                {tableData &&
                                    tableData?.map((item, index) => (

                                        <div key={index} className="product-details clearfix productlist">
                                            <div className="images-product">
                                                <div className="product-gallery">
                                                    <div className="flex-viewport">
                                                        <figure>
                                                            <div className="large_image">
                                                                {/* {console.log("Img----------->", item.ImageDetail)} */}
                                                                {item.ImageDetail != null ?
                                                                    <AutoSlider images={item.ImageDetail} interval={5000} />
                                                                    : <img src={productImgUrl + 'Product.png'} />
                                                                }
                                                                <a></a>
                                                            </div>
                                                            {item.YoutubeLink &&
                                                                <div className="large_image">
                                                                    <YouTubePlayer youtubeLink={item.YoutubeLink} />
                                                                </div>
                                                            }
                                                        </figure>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="summary entry-summary pad10">
                                                <div className='p-0'>
                                                    <h1 className="product_title entry-title pb-0">{item.ProductName}</h1>
                                                    <div className='row'>
                                                        <div className='col-md-6 text-left'>
                                                            {item.Price &&
                                                                <p className="price">
                                                                    {/* <span className="amount"><span>Rs. </span>{item.Price}</span> */}
                                                                    <span className="amount"><span></span>{item.Price}</span>
                                                                </p>
                                                            }
                                                        </div>
                                                        {item.Brochure &&
                                                            <div className='col-md-6'>
                                                                <div className='service-sidebar'>
                                                                    <div className='download'>
                                                                        <div className="item-download p-3">
                                                                            <span className="file pdf">PDF</span>
                                                                            <a href={brochureUrl + item.Brochure} target="_blank">Brouchure <i className="fa fa-download" aria-hidden="true"></i></a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {/* {item.YoutubeLink &&
                                                            <div className='col-md-6'>
                                                                <div className='service-sidebar'>
                                                                    <div className='download'>
                                                                        <div className="item-download p-3">
                                                                            <span className="file pdf">Video</span>
                                                                            <a href={item.YoutubeLink} target="_blank">Youtube<i className="fa fa-youtube" aria-hidden="true"></i></a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        } */}
                                                    </div>

                                                    <div className='scrollable-content p-0'>
                                                        {item.ProductItemSubDetail &&
                                                            <>
                                                                <div className="fp-section-title clearfix">
                                                                    <h2 className='font15'>Details</h2>
                                                                </div>
                                                                <div className="table-responsive">
                                                                    <table className="table table-2">
                                                                        <tbody>
                                                                            {item.ProductItemSubDetail.map((items, index) => (
                                                                                <tr key={index}>
                                                                                    <td>{items.Title}</td>
                                                                                    <td>{items.Description}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </>
                                                        }

                                                        {item.Description &&
                                                            <div className='text-justify' dangerouslySetInnerHTML={{ __html: item.Description }}>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className='row'>
                                                    <div className='mt-10 col-md-5'>
                                                        <a href={"tel:+919825154496"}>
                                                            <button id='btnQuote' className='fp-btn btn' style={{ width: '100%' }}>Call Now</button>
                                                        </a>
                                                    </div>

                                                    <div className='mt-10 col-md-4'>
                                                        <button id='btnQuote' className='fp-btn btn' onClick={() => openModal(item.ProductOtherTypeDetail, item.ProductItemDetailID, item.ProductName)} style={{ width: '100%' }}>Get A Quote</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                            {tableData?.length > 0 && (
                                <>
                                    <button onClick={() => handlepreviousData()} className='fp-btn-2nd readmore'>PREVIOUS</button>
                                    <button onClick={() => handleNextData()} style={{ float: "right" }} className='fp-btn-2nd readmore'>NEXT</button>
                                </>
                            )}
                        </div>
                        <ModalComponent isOpen={modalIsOpen} onRequestClose={closeModal} data={dynamicData} ProductItemDetailID={saveproductItemDetailID} ProductName={saveProductName} onSubmit={closeModal} />

                        {/* <Modal
                            isOpen={isOpen}
                            onRequestClose={onRequestClose}
                            style={customStyles}
                            size="lg"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            className='modal-dialog'
                        >
                            <div>
                                <h2 className='modal-header font20 m-0 pb-10'>Request A Callback</h2>
                                <>
                                    <div className='modal-body'>
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <label htmlFor="mobileNo" className="col-form-label">Mobile No:<span style={{ color: "red" }}>*</span></label>
                                                <input type="text" autoComplete='off' className="form-control allowNumberKey" id="mobileNo" name='mobileNo' required value={formData.mobileNo.textValue} maxLength={10} onChange={handleChange} />
                                                {isSubmit && !formData.mobileNo.textValue && (
                                                    <span style={{ color: "red" }}>
                                                        Please Enter Mobile No
                                                    </span>
                                                )}
                                            </div>
                                        </form>
                                    </div>
                                    <div className='modal-footer'>
                                        <button type="submit" onClick={handleRequestSubmit} className='btn btn-primary'>Submit</button>
                                        <button onClick={handleRequestCloseModel} className='btn btn-danger'>Close</button>
                                    </div>
                                </>
                            </div>
                        </Modal> */}


                        <aside id="primary-sidebar" className="widgets-area primary-sidebar woocommerce  shop-sidebar col-xs-12 col-sm-12 col-md-3">
                            <div id="categories-2" className="widget widget_categories">
                                <h4 className="widget-title">Our Products</h4>
                                <ul>
                                    {productCategoryData &&
                                        productCategoryData.map((item, index) => (
                                            // item.ProductCategory !== nameToExclude &&
                                            <li key={index} value={item.ProductCategoryID} onClick={() => handleMenuClick(item.ProductCategoryID)} className={item.ProductCategory == nameToExclude ? 'productactive' : ''}>
                                                <a href={`/Product/${item.ProductCategory.replace(/\s+/g, '_')}`}>
                                                    {item.ProductCategory}
                                                </a>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </aside>
                    </div>
                </div>
            </div >
        </>
    )
}
export default Product